import { OptimizelyExperiments, OptimizelyFeatureFlags, activateOptimizelyExperiment, setOptimizelyTriggeredCookie } from 'lib/optimizely/optimizelyUtils'
import { SET_OPTIMIZELY_EXPERIMENT, SET_OPTIMIZELY_FEATURE_FLAG } from './actionConstants'

export function setOptimizelyExperiment(flagKey: OptimizelyExperiments) {
  return async(dispatch, getState) => {
    const state = getState() as App.State
    const experimentValues = await activateOptimizelyExperiment(flagKey)
    if (experimentValues?.triggered) {
      setOptimizelyTriggeredCookie(flagKey)
    }

    if (
      state.optimizely.optimizelyExperiments[flagKey]?.variationKey !== experimentValues?.variationKey ||
      state.optimizely.optimizelyExperiments[flagKey]?.triggered !== experimentValues?.triggered
    ) {
      dispatch({
        type: SET_OPTIMIZELY_EXPERIMENT,
        flagKey,
        value: experimentValues,
      })
    }
  }
}

export function setOptimizelyFeatureFlag(flagKey: OptimizelyFeatureFlags) {
  return async(dispatch, getState) => {
    const state = getState() as App.State
    const experimentValues = await activateOptimizelyExperiment(flagKey)

    if (state.optimizely.optimizelyFeatureFlags[flagKey] !== experimentValues?.enabled) {
      dispatch({
        type: SET_OPTIMIZELY_FEATURE_FLAG,
        flagKey,
        value: experimentValues?.enabled,
      })
    }
  }
}
